/* @flow */

import * as _ from "lodash";
import Features from "shared/src/uidispatcherapi/Features";
import { FeatureSessionStore } from "shared/src/uidispatcherapi/FeatureSessionStore";
import CountryUtil from "shared/src/uidispatcherapi/CountryUtil";

type ProfileConfig = {
    profile: string;
    condition?: () => boolean; // condition to be true additional to the feature toggle being active
};

// to enable mocking for testing
const profileMap: { [f: string]: ProfileConfig } = {
    [Features.SD_PARTICIPATES_IN_LTR_TEST]: { profile: "participatesInLtrTest" },
    [Features.SD_ALTERNATIVE_STEMMING]: { profile: "alternativeStemming" },
    [Features.SD_BOOST_OWN_BRAND]: { profile: "MSD-2386-own-brand-boosting" },
    [Features.SD_REDUCE_BOOST_DESCRIPTION_FIELD]: { profile: "MSD-3168-reduce-description-field-boosting" }
};

export function determineSearchProfile(givenProfile?: string | undefined | null): string | undefined {
    return determineProfile(profileMap, givenProfile);
}

const categoryTreeProfileMap = {};

export function determineCategoryTreeProfile(givenProfile?: string | undefined | null): string | undefined {
    return determineProfile(categoryTreeProfileMap, givenProfile);
}

const categorySearchProfileMap = {};

export function determineCategorySearchProfile(givenProfile?: string | undefined | null): string | undefined {
    return determineProfile(categorySearchProfileMap, givenProfile);
}

const suggestProfileMap = {
    [Features.SD_SUGGEST_CONTENT]: { profile: "suggestContent" }
};

export function determineSuggestProfile(): string | undefined {
    return determineProfile(
        suggestProfileMap,
        CountryUtil.getOptionalConfig()?.suggestMoreCategories ? "suggestMoreCategories" : null
    );
}

function determineProfile(
    profileMap: { [f: string]: ProfileConfig },
    givenProfile: string | undefined | null
): string | undefined {
    return (
        _.chain(profileMap)
            .map(
                (value, key) =>
                    (FeatureSessionStore.getMembershipFor(key) === "B" &&
                    (value.condition === undefined || value.condition())
                        ? value.profile
                        : undefined) as string | null | undefined
            )
            .push(givenProfile)
            .compact()
            .join(",")
            .value() || undefined
    );
}
